<div class="message-tile-wrapper">
  <div class="message-tile-container">
    @if (icon) {
      <img class="message-tile-icon" src="{{ icon }}" />
    }
    @if (title) {
      <h3 class="message-tile-title">{{ title }}</h3>
    }
    @if (text) {
      <p class="message-tile-text">{{ text }}</p>
    }
    <ng-content></ng-content>
  </div>
</div>
